import { useState } from 'react';
import { useI18n } from '../../utils/i18n';
import { useToast } from '../ToastProvider';
import { aendereEinstellungen } from '../../services/benutzerEinstellungen';

// #567/#568: Eine Änderung im Einstellungs-Dialog geht sofort an den Server,
// nur mit ihren eigenen Schlüsseln. Während sie unterwegs ist, sperrt der
// Abschnitt seine Schalter; schlägt sie fehl, kommt ein Toast, und die Anzeige
// bleibt beim Stand des Servers.
export default function useSofortSpeichern() {
  const { t } = useI18n();
  const { pushToast } = useToast();
  const [speichert, setSpeichert] = useState(false);

  const speichere = async (aenderung) => {
    if (speichert) return;
    setSpeichert(true);
    try {
      await aendereEinstellungen(aenderung);
    } catch (_) {
      pushToast({ type: 'error', message: t('einstellungen.speichernFehler', 'Die Einstellung konnte nicht gespeichert werden.') });
    } finally {
      setSpeichert(false);
    }
  };

  return { speichert, speichere };
}
